import React, { useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import { Grid, TextField, MenuItem, CircularProgress } from '@mui/material';
import { EmployeeProfileModal } from '@components/molecules/modals/EmployeeProfileModal';
import useDashboardCoursesService from '@/services/dashboard-courses';

import { TableStyled, BodyCell, HeaderCell, HeaderRow, BodyRow, ExcelButton, StyledPagination, PaperContainer } from './style';

const CoursesUserPerfomance = ({ enterpriseId, filterYear, filterMonth }) => {
    const [selectedConsultant, setSelectedConsultant] = useState(null);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);

    const { getConsultantCoursesMetrics, getConsultantCoursesMetricsExport } = useDashboardCoursesService();

    const getData = async () => {
        setLoading(true);
        getConsultantCoursesMetrics(filterYear, filterMonth, enterpriseId, perPage, page)
            .then((resp) => {
                console.log(resp);
                setData(resp.data.consultantsData);
                setPageCount(Math.ceil(resp.data.total / perPage));
            })
            .catch((error) => {})
            .finally(() => setLoading(false));
    };

    const handleExportExcel = async () => {
        const res = await getConsultantCoursesMetricsExport(filterYear, filterMonth, enterpriseId);

        const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);

        const fileName = `consultores_cursos_${filterYear || new Date().getFullYear()}-${
            filterMonth || String(new Date().getMonth() + 1).padStart(2, '0')
        }.xlsx`;

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    };

    useEffect(() => {
        getData();
    }, [perPage, page]);

    return loading ? (
        <PaperContainer height="300px" center sx={{ justifyContent: 'center' }}>
            <CircularProgress />
        </PaperContainer>
    ) : (
        <PaperContainer height="auto">
            <Grid container spacing={2}>
                <Grid item xs={10} sx={{ display: 'flex', alignItems: 'center' }}>
                    <h3>Consultor / Cursos </h3>
                </Grid>
                <Grid item xs={2}>
                    <ExcelButton variant="contained" onClick={handleExportExcel}>
                        <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.5247 23C14.5247 23.2652 14.4194 23.5196 14.2318 23.7071C14.0443 23.8946 13.7899 24 13.5247 24H10.0247C9.7595 24 9.50515 23.8946 9.31761 23.7071C9.13008 23.5196 9.02472 23.2652 9.02472 23V16C9.02472 15.7348 9.13008 15.4804 9.31761 15.2929C9.50515 15.1054 9.7595 15 10.0247 15C10.2899 15 10.5443 15.1054 10.7318 15.2929C10.9194 15.4804 11.0247 15.7348 11.0247 16V22H13.5247C13.7899 22 14.0443 22.1054 14.2318 22.2929C14.4194 22.4804 14.5247 22.7348 14.5247 23ZM6.60597 15.1863C6.49911 15.1099 6.37826 15.0554 6.25032 15.0258C6.12238 14.9961 5.98985 14.992 5.86032 15.0136C5.73078 15.0352 5.60676 15.0821 5.49534 15.1516C5.38393 15.2211 5.2873 15.3119 5.21097 15.4188L3.52472 17.78L1.83847 15.4188C1.76486 15.3055 1.66906 15.2083 1.55687 15.1331C1.44467 15.0579 1.31839 15.0062 1.18566 14.9811C1.05293 14.956 0.916494 14.9581 0.784586 14.9872C0.652678 15.0163 0.528032 15.0718 0.41817 15.1504C0.308308 15.229 0.215509 15.329 0.14537 15.4445C0.0752316 15.5599 0.0292089 15.6884 0.010079 15.8221C-0.00905094 15.9558 -0.000891797 16.092 0.0340648 16.2225C0.0690214 16.353 0.13005 16.475 0.213469 16.5812L2.29597 19.5L0.21097 22.4188C0.0706511 22.6346 0.019019 22.8963 0.066825 23.1494C0.114631 23.4024 0.25819 23.6272 0.467609 23.777C0.677028 23.9268 0.936164 23.9901 1.19106 23.9536C1.44595 23.9172 1.67696 23.7838 1.83597 23.5812L3.52472 21.22L5.21097 23.5812C5.36998 23.7838 5.60099 23.9172 5.85588 23.9536C6.11077 23.9901 6.36991 23.9268 6.57933 23.777C6.78875 23.6272 6.93231 23.4024 6.98011 23.1494C7.02792 22.8963 6.97629 22.6346 6.83597 22.4188L4.75347 19.5L6.83847 16.5812C6.9148 16.4744 6.96934 16.3535 6.99897 16.2256C7.02859 16.0977 7.03273 15.9651 7.01114 15.8356C6.98955 15.7061 6.94266 15.582 6.87314 15.4706C6.80362 15.3592 6.71283 15.2626 6.60597 15.1863ZM18.9735 18.4137C18.4735 18.2687 17.956 18.12 17.6672 17.9338C17.511 17.8312 17.5135 17.8088 17.5272 17.6963C17.5291 17.6054 17.5528 17.5162 17.5963 17.4364C17.6398 17.3566 17.7018 17.2883 17.7772 17.2375C18.3522 16.8475 19.6947 17.0225 20.2547 17.1675C20.5113 17.235 20.7842 17.1977 21.0133 17.064C21.2425 16.9303 21.4091 16.711 21.4766 16.4544C21.5441 16.1978 21.5068 15.9249 21.3731 15.6957C21.2394 15.4666 21.0201 15.3 20.7635 15.2325C20.4997 15.1637 18.1385 14.58 16.6597 15.5775C16.3479 15.7882 16.0861 16.0647 15.8928 16.3876C15.6995 16.7105 15.5794 17.0719 15.541 17.4463C15.291 19.4313 17.2472 19.9975 18.416 20.335C19.9235 20.7712 20.056 20.95 20.0135 21.2838C19.9747 21.585 19.856 21.7 19.7447 21.775C19.1697 22.1575 17.8497 21.9688 17.3022 21.8188C17.0461 21.7476 16.7723 21.7812 16.5409 21.912C16.4263 21.9768 16.3256 22.0635 16.2446 22.1671C16.1635 22.2708 16.1037 22.3894 16.0685 22.5163C16.0333 22.6431 16.0234 22.7756 16.0394 22.9062C16.0554 23.0368 16.0969 23.163 16.1617 23.2776C16.2925 23.509 16.5099 23.6789 16.766 23.75C17.3858 23.9133 18.0238 23.9973 18.6647 24C19.3922 24 20.2022 23.875 20.851 23.4425C21.171 23.2297 21.4399 22.9485 21.6383 22.6194C21.8367 22.2902 21.9597 21.9211 21.9985 21.5387C22.2747 19.375 20.2097 18.7712 18.9735 18.4137ZM0.0247193 11V2C0.0247193 1.46957 0.235433 0.960859 0.610506 0.585787C0.985578 0.210714 1.49429 3.09198e-07 2.02472 3.09198e-07H14.0247C14.1561 -0.000102986 14.2862 0.0256758 14.4076 0.0758639C14.529 0.126052 14.6393 0.199666 14.7322 0.2925L21.7322 7.2925C21.8251 7.38544 21.8987 7.49576 21.9489 7.61715C21.999 7.73855 22.0248 7.86864 22.0247 8V11C22.0247 11.2652 21.9194 11.5196 21.7318 11.7071C21.5443 11.8946 21.2899 12 21.0247 12C20.7595 12 20.5051 11.8946 20.3176 11.7071C20.1301 11.5196 20.0247 11.2652 20.0247 11V9H14.0247C13.7595 9 13.5051 8.89464 13.3176 8.70711C13.1301 8.51957 13.0247 8.26522 13.0247 8V2H2.02472V11C2.02472 11.2652 1.91936 11.5196 1.73183 11.7071C1.54429 11.8946 1.28994 12 1.02472 12C0.759503 12 0.505149 11.8946 0.317613 11.7071C0.130076 11.5196 0.0247193 11.2652 0.0247193 11ZM15.0247 7H18.6097L15.0247 3.41375V7Z"
                                fill="white"
                            />
                        </svg>
                        Exportar Excel
                    </ExcelButton>
                </Grid>
                <Grid item xs={12}>
                    <TableStyled container xs={12}>
                        <HeaderRow container xs={12}>
                            <HeaderCell item xs={6} align="left">
                                Técnico
                            </HeaderCell>
                            <HeaderCell item xs={3}>
                                Iniciou um curso
                            </HeaderCell>
                            <HeaderCell item xs={3}>
                                Finalizou um curso
                            </HeaderCell>
                        </HeaderRow>
                        {data.map((consultant) => (
                            <BodyRow container xs={12} key={consultant.id}>
                                <BodyCell item xs={6} align="left">
                                    {consultant.name}
                                </BodyCell>
                                <BodyCell item xs={3}>
                                    {consultant.courses_started}
                                </BodyCell>
                                <BodyCell item xs={3}>
                                    {consultant.courses_finished}
                                </BodyCell>
                            </BodyRow>
                        ))}
                    </TableStyled>
                    <Grid item xs={12}>
                        <Grid container xs={12} justifyContent="space-between" alignItems="center" mt={2}>
                            <Grid item>
                                <TextField
                                    select
                                    size="small"
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(e.target.value);
                                        setPage(1);
                                    }}
                                >
                                    {[10, 20, 50, 100].map((opt) => (
                                        <MenuItem key={opt} value={opt}>
                                            {opt}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item>
                                <StyledPagination
                                    count={pageCount}
                                    page={page}
                                    onChange={(_, value) => setPage(value)}
                                    variant="outlined"
                                    shape="rounded"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <EmployeeProfileModal
                    open={selectedConsultant !== null}
                    handleClose={(e) => {
                        e.stopPropagation();
                        setSelectedConsultant(null);
                    }}
                    profile={selectedConsultant}
                />
            </Grid>
        </PaperContainer>
    );
};

export default CoursesUserPerfomance;

CoursesUserPerfomance.propTypes = {
    years: PropTypes.array
};
